module.exports = __webpack_public_path__ + "img/picture11.d087515d.png";